// extracted by mini-css-extract-plugin
module.exports =  {"widthXxs":"320","widthXs":"576","widthSm":"768","widthMd":"992","widthLg":"1200","widthXl":"1440","widthMinGrid":"620","fa-spin":"fa-spin--kLRy22Dcn-JoZvjBaZMnhA=="};